import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { OUnitCode, OUnitCodeCreateDto, OUnitCodeUpdateDto } from '@zayan-erp/home-building';
import { API_CONFIG, ApiCallingV2Service } from '@zayan-erp/shared';
import { Project } from '@zayan-erp/home-building';

@Injectable({
  providedIn: 'root'
})
export class OUnitCodeService {
  #http = inject(ApiCallingV2Service);
  #apiConfig = inject(API_CONFIG);
  baseUrl = this.#apiConfig.baseUrlV2;

  readOUnitCodes(): Observable<OUnitCode[]> {
    return this.#http.getData(`${this.baseUrl}/ounitcode`, { showLoader: true, showMessage: false });
  }

  createOUnitCode(ounitCode: OUnitCodeCreateDto): Observable<unknown> {
    return this.#http.postData(
      `${this.baseUrl}/ounitcode`,
      { showLoader: true, showMessage: true, message: 'OUnit Code created successfully' },
      ounitCode
    );
  }

  updateOUnitCode(ounitCodeId: string, ounitCode: OUnitCodeUpdateDto): Observable<unknown> {
    return this.#http.putData(`${this.baseUrl}/ounitcode/${ounitCodeId}`, ounitCode, {
      showLoader: true,
      showMessage: true,
      message: 'OUnit Code updated successfully'
    });
  }

  deleteOUnitCode(codes: string[]): Observable<unknown> {
    return this.#http.postData(
      `${this.baseUrl}/ounitcode/bulk-delete`,
      { showLoader: true, showMessage: true, message: 'OUnit Code deleted successfully' },
      codes
    );
  }

  getOUnitCodeByCode(ounitCode: string): Observable<OUnitCode> {
    return this.#http.getData(`${this.baseUrl}/ounitcode/code/${ounitCode}`, { showLoader: true, showMessage: false });
  }

  upsertOUnitCodes(ounitCodes: OUnitCodeCreateDto[]): Observable<unknown> {
    return this.#http.postData(
      `${this.baseUrl}/ounitcode/bulk-upsert`,
      { showLoader: true, showMessage: true, message: 'OUnit Codes added successfully' },
      ounitCodes
    );
  }

  readOunitProjects(ounitId: string): Observable<Project[]> {
    return this.#http.getData(`${this.baseUrl}/ounitcode/${ounitId}/projects`, {
      showLoader: true,
      showMessage: false
    });
  }
}
